<form [formGroup]="searchForm">

<div class="container-fluid" >
  <div id="header" class="navbar-central">
    <div class="navbar">
    <a href="auth/login"><img src="../../../../../assets/images/base_logo_transparent_background.png" style="width: 150px; height: 23px;"></a>
    </div>

    <div id="infos-right">
      <ul>
        <li><a href="auth/login" class="btn btn-secondary">Entrar</a></li>
        <li><a href="auth/login" class="btn btn-primary">Fale Conosco</a></li>
      </ul>
    </div>
  </div>

  <!-- content -->
  <div class="container-fluid page">
    <div class="search-central">
      
      <h2>Olá, como podemos ajudar você?</h2>
      
      <div class="search-bar"  >
        <input class="form-control"  formControlName="searchtext"  type="text" placeholder="Digite sua dúvida ou uma palavra-chave" (keyup.enter)="send()">
      </div> 

    </div>
  </div>
  <!-- / content -->
</div>

<div class="bg-content-central" >
  <div class="container">
      <div class="row">
        <div class="col-md-3">
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="custom-tree-node-padding">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="10">
              <!-- use a disabled button to provide padding for tree leaf -->
              <button mat-icon-button disabled></button>
              <a *ngIf="node.type === 'article'; else notArticle" href="javascript:void(0)" (click)="loadArticle(node.id)">{{node.name}}</a>
              <ng-template #notArticle><h3>{{node.name}}</h3></ng-template>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="10">
              <button mat-icon-button matTreeNodeToggle
                      [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              <a *ngIf="node.type === 'article'; else notArticle" href="javascript:void(0)" (click)="loadArticle(node.id)">{{node.name}}</a>
              <ng-template #notArticle><h3>{{node.name}}</h3></ng-template>
            </mat-tree-node>
          </mat-tree>

        </div>
        <div class="col-md-9">
          <h3>{{articleTitle}}</h3>
          <div class="detalhes-artigo" *ngIf="createdDate">
            Criado  em {{createdDate}}
          </div> 


            <div class="central-body">
              <div [innerHTML]="htmlContent"></div>
            </div>


            <!-- Div de avaliação -->
          <div class="avaliacao-container" *ngIf="articleTitle && !avaliacaoEnviada">
            <input type="hidden" formControlName="idArtigo" [value]="idArtigo">
            <p>Este artigo foi útil para você?</p>
            <div class="botoes-avaliacao">
                <button 
                class="btn btn-primary" 
                [ngClass]="{'selecionado': searchForm.get('avaliacao')?.value === true}" 
                (click)="avaliar(true)">
                Sim 👍
              </button>
              <button 
                class="btn btn-primary" 
                [ngClass]="{'selecionado': searchForm.get('avaliacao')?.value === false}" 
                (click)="avaliar(false)">
                Não 👎
              </button>
            </div>

            <div *ngIf="searchForm.get('avaliacao')?.value !== null" class="comentario-container">
              <p>Complemente sua avaliação com um comentário ou simplesmente clique no botão enviar.</p>
              <textarea formControlName="comentario"  placeholder="Comentário"></textarea>
                <!-- Substitui o botão "Enviar" por um ícone de carregamento enquanto isLoading for true -->
              <button *ngIf="!isLoading" class="btn btn-success" (click)="enviarAvaliacao()">Enviar</button>
              <div *ngIf="isLoading" class="loading-container">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Carregando...
              </div>
            </div>
          </div>

          <!-- Exibe uma mensagem centralizada após o envio da avaliação -->
          <div *ngIf="avaliacaoEnviada" class="mensagem-final">
            <p>Avaliação enviada com sucesso!</p>
          </div>

        </div>
      </div>
    </div>
  </div>
  
</form>
